// Type converters
const StringParam = {
  encode: (value: string) => value,
  decode: (value: string | null) => value || '',
}

const NumberParam = {
  encode: (value: number) => String(value),
  decode: (value: string | null) => (value != null ? Number(value) : null),
}

type ParamType<T> = {
  encode: (value: T) => string
  decode: (value: string | null) => T
}

// Custom hook definition
function useQueryParam<T>(
  key: string,
  paramType: ParamType<T>
): [T, (newValue: T | null) => void] {
  // Get the current value of the query parameter
  const queryValue = paramType.decode(
    new URLSearchParams(window.location.search).get(key)
  )

  // Function to update the query parameter
  const setQueryParam = (newValue: T | null) => {
    const newParams = new URLSearchParams(window.location.search)
    if (newValue != null) {
      newParams.set(key, paramType.encode(newValue))
    } else {
      newParams.delete(key)
    }
    const query = newParams.toString()
    const newUrl = `${window.location.pathname}${query ? '?' : ''}${query}`
    window.history.pushState({}, '', newUrl)
  }

  return [queryValue, setQueryParam]
}

export { useQueryParam, StringParam, NumberParam }
